const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const DIGIT = '0123456789';
const SYMBOL = '!@#$%^&*';

function randomChar(set: string): string {
  const max = 256 - (256 % set.length);
  const arr = new Uint8Array(1);

  do {
    crypto.getRandomValues(arr);
  } while (arr[0] >= max);

  return set[arr[0] % set.length];
}

function secureShuffle(arr: string[]): void {
  for (let i = arr.length - 1; i > 0; i--) {
    const max = 256 - (256 % (i + 1));
    const rand = new Uint8Array(1);

    let r;
    do {
      crypto.getRandomValues(rand);
      r = rand[0];
    } while (r >= max);

    const j = r % (i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
}

export function generatePassword(length = 12): string {
  if (length < 4) {
    throw new Error('Password length must be at least 4');
  }

  const all = LOWER + UPPER + DIGIT + SYMBOL;

  const password: string[] = [
    randomChar(LOWER),
    randomChar(UPPER),
    randomChar(DIGIT),
    randomChar(SYMBOL),
  ];

  for (let i = password.length; i < length; i++) {
    password.push(randomChar(all));
  }

  secureShuffle(password);

  return password.join('');
}
